<template>
  <div :class="classes">
    <div>
      <line-chart :chart-data="chartData" :options="options" />
    </div>
  </div>
</template>
<script>
import LineChart from "./charts/LineChart";
export default {
  name: "bx-line-chart",
  components: {
    LineChart
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom"
        }
      }
    };
  },
  computed: {
    classes() {
      const classes = ["bx-line-chart"];
      return classes;
    }
  }
};
</script>
